import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import './Auth.css';

function Register() {
  const [formData, setFormData] = useState({
    email: '', username: '', full_name: '', password: '', confirmPassword: '',
  });
  const [error, setError] = useState('');
  const { register, loading } = useAuthStore();
  const navigate = useNavigate();

  const handleChange = e => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    try {
      await register({
        email: formData.email,
        username: formData.username,
        full_name: formData.full_name,
        password: formData.password,
      });
      navigate('/login');
    } catch (err) {
      setError(err.response?.data?.detail || 'Registration failed');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-panel-left">
        <div className="auth-brand">
          <div className="auth-brand-logo">Ecom<span>Store</span></div>
          <h2>Join thousands of happy shoppers</h2>
          <p>Create your free account and start shopping the best deals today.</p>
          <ul className="auth-perks">
            <li>Free shipping on your first order</li>
            <li>Access to exclusive member deals</li>
            <li>Easy order tracking & returns</li>
          </ul>
        </div>
      </div>

      <div className="auth-panel-right">
        <div className="auth-box">
          <div className="auth-box-header">
            <h1>Create account</h1>
            <p>It's free and only takes a minute</p>
          </div>

          <div className="auth-card">
            {error && <div className="alert alert-error">{error}</div>}

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="full_name">Full Name</label>
                <input
                  id="full_name" name="full_name" type="text"
                  value={formData.full_name} onChange={handleChange}
                  placeholder="John Doe" required
                />
              </div>

              <div className="form-group">
                <label htmlFor="username">Username</label>
                <input
                  id="username" name="username" type="text"
                  value={formData.username} onChange={handleChange}
                  placeholder="johndoe" required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email address</label>
                <input
                  id="email" name="email" type="email"
                  value={formData.email} onChange={handleChange}
                  placeholder="you@example.com" required autoComplete="email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="password">Password</label>
                <input
                  id="password" name="password" type="password"
                  value={formData.password} onChange={handleChange}
                  placeholder="At least 8 characters" required autoComplete="new-password"
                />
              </div>

              <div className="form-group">
                <label htmlFor="confirmPassword">Confirm Password</label>
                <input
                  id="confirmPassword" name="confirmPassword" type="password"
                  value={formData.confirmPassword} onChange={handleChange}
                  placeholder="••••••••" required autoComplete="new-password"
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary auth-submit"
                disabled={loading}
              >
                {loading ? 'Creating account…' : 'Create account'}
              </button>
            </form>
          </div>

          <p className="auth-footer-text">
            Already have an account? <Link to="/login">Sign in</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Register;
